import IDMGlobals from './../../IDMGlobals';
//
export default class APIUserPartition {
  constructor(API) {
    this.api = API;
  }
  async readAll(userID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = IDMGlobals.APIPath_User + userID + IDMGlobals.APIPath_UserPartitions;
    return await req.exec();
  }
  async readSome(partsID, userID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = IDMGlobals.APIPath_User + userID + IDMGlobals.APIPath_UserSomePartition;
    req.appendQueryParam(IDMGlobals.URLQueryParam_PartsID, JSON.stringify(partsID))
    return await req.exec();
  }
  async read(partID, userID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = IDMGlobals.APIPath_User + userID + IDMGlobals.APIPath_UserPartition + partID;
    return await req.exec();
  }
  async set(partObj, partID, userID) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = IDMGlobals.APIPath_User + userID + IDMGlobals.APIPath_UserPartition + partID;
    req.body = {...partObj};
    return await req.exec();
  }
  async setMultiple(parts, userID) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = IDMGlobals.APIPath_User + userID + IDMGlobals.APIPath_UserPartitions;
    req.body = {...parts};
    return await req.exec();
  }
  async delete(userID, partID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = IDMGlobals.APIPath_User + userID + IDMGlobals.APIPath_UserPartition + partID;
    return await req.exec();
  }
  // Search
  async searchPartitionsFromUsers(userIDs, filter) {
    const req = await this.api.newBaseRequest('POST');
    req.path = IDMGlobals.APIPath_UsersPartsSearch;
    req.body = { userIDs, filter: (filter ? filter : {}) };
    return await req.exec();
  }
  async searchSpecifiedPartitionsFromUsers(userIDs, partIDs, filter) {
    const req = await this.api.newBaseRequest('POST');
    req.path = IDMGlobals.APIPath_UsersPartsByIDsSearch;
    req.body = { userIDs, partIDs, filter: (filter ? filter : {}) };
    return await req.exec();
  }
}
